import { render, staticRenderFns } from "./QuoteResume.vue?vue&type=template&id=152fe5aa&scoped=true&"
import script from "./QuoteResume.vue?vue&type=script&lang=js&"
export * from "./QuoteResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152fe5aa",
  null
  
)

export default component.exports